import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSingaporeFlag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0003 60.0005C37.9567 60.0002 45.5871 56.8395 51.2131 51.2134C56.8391 45.5874 59.9998 37.9569 60 30.0005H0C0.000154577 37.957 3.16095 45.5876 8.78707 51.2136C14.4132 56.8397 22.0438 60.0004 30.0003 60.0005Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0003 0.000976567C26.0606 0.000907978 22.1596 0.776814 18.5198 2.28439C14.88 3.79197 11.5728 6.0017 8.78702 8.78741C6.00123 11.5731 3.79141 14.8802 2.28373 18.52C0.776055 22.1597 4.07549e-05 26.0608 0 30.0004H60C59.9999 22.0441 56.8392 14.4136 51.2132 8.78762C45.5871 3.16164 37.9566 0.000999653 30.0003 0.000976567V0.000976567Z",
			fill: "#ED4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.232 15.4732L17.9997 14.5281L19.5253 14.5232L20.0003 13.001L20.4772 14.5232L21.9998 14.5281L20.7698 15.4743L21.2357 17.001L20.0003 16.0621L18.7661 17.001L19.232 15.4732Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.2322 15.4732L26.0003 14.5281L27.5252 14.5232L28.0001 13.001L28.4766 14.5232L30.0004 14.5281L28.7699 15.4743L29.2362 17.001L28.0001 16.0621L26.7663 17.001L27.2322 15.4732Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.2321 20.4723L19.0002 19.5272L20.5254 19.5227L21 18.0005L21.4769 19.5227L23.0002 19.5272L21.7702 20.4734L22.2365 22.0006L21 21.0616L19.7658 22.0006L20.2321 20.4723Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.2317 20.4723L25.0005 19.5272L26.5254 19.5227L27 18.0005L27.4773 19.5227L28.9998 19.5272L27.7706 20.4734L28.2365 22.0006L27 21.0616L25.7658 22.0006L26.2317 20.4723Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.2322 12.4727L21.9999 11.528L23.5251 11.5227L24.0001 10.0005L24.4774 11.5227L26.0003 11.528L24.7699 12.4738L25.2362 14.0006L24.0001 13.0619L22.7659 14.0006L23.2322 12.4727Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.4117 25.959C17.6442 25.959 13.7795 21.9029 13.7795 16.9001C13.7795 11.897 17.6442 7.84089 22.4117 7.84089C22.7565 7.84291 23.1009 7.86636 23.4428 7.91109C22.2143 7.31338 20.8663 7.0022 19.5002 7.00098C14.2562 7.00098 10.0001 11.478 10.0001 17.0011C10.0001 22.5239 14.2562 27.0006 19.5002 27.0006C21.0793 27 22.6307 26.5861 24.0002 25.8C23.4771 25.9042 22.9451 25.9575 22.4117 25.959Z",
			fill: "white"
		})
	]
});
export default SvgSingaporeFlag;
